import { render, staticRenderFns } from "./CourseSections.vue?vue&type=template&id=f1e5b20a&scoped=true"
import script from "./CourseSections.vue?vue&type=script&lang=js"
export * from "./CourseSections.vue?vue&type=script&lang=js"
import style0 from "./CourseSections.vue?vue&type=style&index=0&id=f1e5b20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1e5b20a",
  null
  
)

export default component.exports